<script setup>
  import { defineProps, computed } from 'vue';

  const props = defineProps({
    pokeIndex: Number,
    trioResults: Object
  })

  const cw = computed(()=>{
    return ((props.pokeIndex-1+1)%3)+1;
  })
  const acw = computed(()=>{
    return ((props.pokeIndex-1+2)%3)+1;
  })

  const isWinner = computed(()=>{
    return (
      props.trioResults['p'+props.pokeIndex+'-rating'] < props.trioResults['p'+cw.value+'-rating']
      && props.trioResults['p'+props.pokeIndex+'-rating'] < props.trioResults['p'+acw.value+'-rating']
    )
  })
  const isLoser = computed(()=>{
    return (
      props.trioResults['p'+props.pokeIndex+'-rating'] > props.trioResults['p'+cw.value+'-rating']
      && props.trioResults['p'+props.pokeIndex+'-rating'] > props.trioResults['p'+acw.value+'-rating']
    )
  })
</script>
<template>
  <div :class="{
    'tool-card rating-card border shadow text-center p-2': true,
    '!bg-green-400/10 !border-green-200 dark:!border-green-700': isWinner,
    '!bg-red-400/10 !border-red-200 dark:!border-red-700': isLoser,
    '!bg-white/10 border-gray-200 dark:!border-gray-700': !(isLoser || isWinner),
  }">
    Weakness: {{ props.trioResults['p'+props.pokeIndex+'-rating']*100 }}%
    <span v-if="isWinner" class="winner ml-1 bg-green-700 rounded px-2 py-0.5 text-sm text-white font-bold">Winner</span>
    <span v-else-if="isLoser" class="loser ml-1 bg-red-700 rounded px-2 py-0.5 text-sm text-white font-bold">Loser</span>
  </div>
</template>
